import { Flex, Input, Select, Typography } from 'antd';
import FormItem from 'components/FormItem';
import { getLocationKitchenTipOptions } from 'components/kitchenTipOptions';
import React from 'react';

const options = Array.from(new Array(4)).map((_, i) => ({ value: i, label: `Preset ${i + 1}` }));

function Tip({ organizationEnableKitchenTip = false }) {
  const kitchenTipOptions = getLocationKitchenTipOptions(organizationEnableKitchenTip);

  return (
    <>
      <FormItem
        name="enable_kitchen_tip"
        label="Kitchen Tip (delivery)"
        tooltip="When enabled, delivery checkout can collect a kitchen tip. Inherit uses the organization setting (default off)."
      >
        <Select options={kitchenTipOptions} allowClear={false} />
      </FormItem>
      <Typography.Paragraph type="secondary">
        When Kitchen Tip is enabled, it starts at $0 with nothing pre-selected. Pickup tip is unchanged.
      </Typography.Paragraph>
      <Flex gap="middle">
        {options.map((o, index) => (
          <FormItem key={index} name={['tip_options', o.value]} label={o.label}>
            <Input type="number" prefix="%" />
          </FormItem>
        ))}
      </Flex>
      <FormItem name="tip_default_value" label="Tip default value">
        <Select options={options} />
      </FormItem>
      <FormItem
        name="tip_description"
        label="Tip description"
        rules={[{ required: true }]}
      >
        <Input.TextArea />
      </FormItem>

    </>

  );
}

export default Tip;
